import type { HTMLAttributes } from "react";
import { useId, useMemo } from "react";
import { tv } from "tailwind-variants";

import { FormItemContext } from "../form.context";

export function FormItem({
  ref,
  className,
  ...props
}: HTMLAttributes<HTMLDivElement> & { ref?: React.RefObject<HTMLDivElement | null> }) {
  const id = useId();
  const value = useMemo(() => ({ id }), [id]);

  return (
    <FormItemContext value={value}>
      <div ref={ref} className={tv({ base: "relative space-y-2" })({ className })} {...props} />
    </FormItemContext>
  );
}
FormItem.displayName = "FormItem";
